import * as React from "react"
import { usePage } from "@inertiajs/react"
import {
  IconDashboard,
  IconDatabase,
  IconFileWord,
  IconHelp,
  IconListDetails,
  IconReport,
  IconSearch,
  IconSettings,
  IconCirclePlusFilled,
  IconTags,
  IconFileTypeJs,
  IconRuler,
  IconFiles,
  IconKey,
  IconServer,
  IconTrash,
  IconApi,
  IconBrandReact,
} from "@tabler/icons-react"
// @ts-ignore
import logo from "/assets/logo.svg"

import { NavDocumentation } from "./nav-documentation"
import { NavMain } from "@/components/nav-main"
import { NavSecondary } from "@/components/nav-secondary"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

const data = {
  user: {
    name: "shadcn",
    email: "m@example.com",
    avatar: "/avatars/shadcn.jpg",
  },
  navMain: [
    {
      title: "Quick Start",
      url: "/documentation/quick-start", 
      icon: IconCirclePlusFilled,
    },
    {
      title: "Dashboard",
      url: "/dashboard",
      icon: IconDashboard,
      requiresAuth: true,
    },
  ],
  navSecondary: [
    {
      title: "Get Help",
      url: "https://simplefileupload.com/contact",
      icon: IconHelp,
    },
  ],
  frameworks: [
    {
      title: "React",
      url: "/documentation/react",
      icon: IconBrandReact,
    },
  ],
  documents: [
    {
      title: "JavaScript Events",
      url: "/documentation/javascript-events",
      icon: IconListDetails,
    },
    {
      title: "Tagging Files",
      url: "/documentation/tagging-files",
      icon: IconTags,
    },
    {
      title: "Limit File Types",
      url: "/documentation/limit-file-types",
      icon: IconFileTypeJs,
    },
    {
      title: "Limit File Size",
      url: "/documentation/limit-file-size",
      icon: IconRuler,
    },
    {
      title: "Limit Number of Files",
      url: "/documentation/limit-number-of-files",
      icon: IconFiles,
    },
    {
      title: "Serving Files",
      url: "/documentation/serving-files",
      icon: IconServer,
    },
  ],
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { props: pageProps } = usePage<{ auth: { isAuthenticated: boolean; user: any } }>()
  const isAuthenticated = pageProps.auth?.isAuthenticated ?? false
  const user = pageProps.auth?.user
  
  // Filter nav items based on authentication
  const filteredNavMain = data.navMain.filter(item => !item.requiresAuth || isAuthenticated)
  
  // API section with dynamic user ID
  const apiItems = [
    {
      title: "Deleting Files",
      url: "/documentation/deleting-files",
      icon: IconTrash,
    },
    {
      title: "API Documentation",
      url: "/documentation/api-documentation",
      icon: IconApi,
    },
    {
      title: "Manage API Keys",
      url: `/account/users/${user?.id}/api_keys`,
      icon: IconKey,
      requiresAuth: true,
    },
  ]
  
  // Filter API items based on authentication
  const filteredApiItems = apiItems.filter(item => !item.requiresAuth || isAuthenticated)
  
  return (
    <Sidebar collapsible="offcanvas" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              className="data-[slot=sidebar-menu-button]:!p-1.5"
            >
              <a href="https://simplefileupload.com">
                <img src={logo} alt="Simple File Upload" className="h-5 w-5" />
                <span className="text-base font-semibold">Simple File Upload</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={filteredNavMain} />
        <NavDocumentation items={data.documents} />
        <NavDocumentation items={data.frameworks} label="Frameworks" />
        <NavDocumentation items={filteredApiItems} label="API" />
        {isAuthenticated && (
          <NavSecondary items={data.navSecondary} className="mt-auto" />
        )}
      </SidebarContent>
      {isAuthenticated && (
        <SidebarFooter>
          <NavUser user={user || data.user} />
        </SidebarFooter>
      )}
    </Sidebar>
  )
}
